import { combineReducers } from 'redux';
import moment from 'moment';
import { put, takeEvery } from 'redux-saga/effects';
import prepareBody from '../utils/prepareBody';
import { selectPlanId, selectRunnerId } from './auth';
import { fetchWorkouts, clearAllWorkouts } from './workouts';
import isSet from '../utils/isSet';
import getPageY from '../utils/getPageY';

export const CHANGE_FIELD = 'events/CHANGE_FIELD';
export const CHANGE_SEARCH_FILTER = 'events/CHANGE_SEARCH_FILTER';
export const OPEN_MODAL = 'events/OPEN_MODAL';
export const CLOSE_MODAL = 'events/CLOSE_MODAL';
export const OPEN_TIP_MODAL = 'events/OPEN_TIP_MODAL';
export const CLOSE_TIP_MODAL = 'events/CLOSE_TIP_MODAL';
export const SAVE_EVENTS = 'events/SAVE_EVENTS';
export const SAVE_EVENTS_SUCCESS = 'events/SAVE_EVENTS_SUCCESS';
export const SAVE_EVENTS_FAILURE = 'events/SAVE_EVENTS_FAILURE';
export const FETCH_EVENTS = 'events/FETCH_EVENTS';
export const FETCH_EVENTS_SUCCESS = 'events/FETCH_EVENTS_SUCCESS';
export const FETCH_EVENTS_FAILURE = 'events/FETCH_EVENTS_FAILURE';
export const SET_ERROR = 'events/SET_ERROR';
export const GET_RACE_INFO = 'events/GET_RACE_INFO';
export const GET_RACE_INFO_SUCCESS = 'events/GET_RACE_INFO_SUCCESS';
export const GET_RACE_INFO_FAILURE = 'events/GET_RACE_INFO_FAILURE';
export const FETCH_NEW_EVENTS = 'events/FETCH_NEW_EVENTS';
export const FETCH_NEW_EVENTS_SUCCESS = 'events/FETCH_NEW_EVENTS_SUCCESS';
export const FETCH_NEW_EVENTS_FAILURE = 'events/FETCH_NEW_EVENTS_FAILURE';


export function list(state = [], action) {
    switch (action.type) {
        case FETCH_EVENTS_SUCCESS:
            return { ...action.result };
        case SAVE_EVENTS_SUCCESS:
            return {
                complete: action.result.complete,
                upcoming: action.result.upcoming,
            };
        default:
            return state;
    }
}

export function form(state = {}, action) {
    switch (action.type) {
        case SAVE_EVENTS_SUCCESS:
        case CLOSE_MODAL:
            return {};
        case CHANGE_FIELD:
            return {
                ...state,
                [action.key]: action.val,
            };
        case OPEN_MODAL: {
            if (!action.event) {
                return {
                    name: '',
                    date: '',
                    dist: '',
                    hr: '',
                    min: '',
                    sec: '',
                };
            }
            return {
                ...action.event,
                original_name: action.event.name,
                original_date: action.event.date,
            };
        }
        default:
            return state;
    }
}

export function open(state = false, action) {
    switch (action.type) {
        case OPEN_MODAL:
            return true;
        case SAVE_EVENTS_SUCCESS:
        case CLOSE_MODAL:
            return false;
        default:
            return state;
    }
}

export function loading(state = false, action) {
    switch (action.type) {
        case FETCH_EVENTS: {
            if (action.key !== 'date') {
                return state;
            }
            return true;
        }
        case FETCH_EVENTS_SUCCESS:
        case FETCH_EVENTS_FAILURE:
            return false;
        default:
            return state;
    }
}

export function errors(state = {}, action) {
    switch (action.type) {
        case CHANGE_FIELD: {
            return {
                ...state,
                [action.key]: null,
            };
        }
        case SET_ERROR:
            return {
                ...state,
                [action.key]: action.error,
            };
        case CLOSE_MODAL:
            return {};
        default:
            return state;
    }
}

export function eventError(state = {}, action) {
    switch (action.type) {
        case FETCH_EVENTS_SUCCESS:
            return action.result.error;
        default:
            return state;
    }
}

export function formLoading(state = false, action) {
    switch (action.type) {
        case SAVE_EVENTS:
            return true;
        case SAVE_EVENTS_SUCCESS:
        case SAVE_EVENTS_FAILURE:
        case CLOSE_MODAL:
            return false;
        default:
            return state;
    }
}

export function goalInfo(state = {}, action) {
    switch (action.type) {
        case GET_RACE_INFO_SUCCESS:
            return {
                ...state,
                ...action.result,
            };
        default:
            return state;
    }
}

export function showGoalCard(state = false, action) {
    switch (action.type) {
        case GET_RACE_INFO_SUCCESS:
            return checkGoalInfo(action.result);
        default:
            return state;
    }
}

export function goalInfoLoading(state = null, action) {
    switch (action.type) {
        case GET_RACE_INFO:
            return true;
        case GET_RACE_INFO_SUCCESS:
        case GET_RACE_INFO_FAILURE:
            return false;
        default:
            return state;
    }
}

export function yPosition(state = null, action) {
    switch (action.type) {
        case OPEN_MODAL:
            return action.yPos;
        default:
            return state;
    }
}
export function findEvents(state = {
    searchFields: {
        searchStartDate: moment().toDate(),
        searchEndDate: moment().add(6, 'months').toDate(),
        searchState: 'NY',
        searchDistance: '',
    },
    errors: {},
}, action) {
    switch (action.type) {
        case SET_ERROR:
            return {
                ...state,
                errors: {
                    [action.key]: action.error,
                },
            };
        case CHANGE_SEARCH_FILTER:
            return {
                ...state,
                searchFields: {
                    ...state.searchFields,
                    [action.key]: action.val,
                },
            };
        case FETCH_NEW_EVENTS:
            return {
                ...state,
                eventsList: null,
                loading: true,
            };
        case FETCH_NEW_EVENTS_SUCCESS:
            return {
                ...state,
                loading: false,
                eventsList: action.result,
            };
        case FETCH_NEW_EVENTS_FAILURE:
            return {
                ...state,
                loading: false,
            };
        default:
            return state;
    }
}

export function* refreshFullPlan() {
    yield put(clearAllWorkouts());
    return yield put(fetchWorkouts());
}

export function* refreshEvents() {
    return yield put(fetchEvents());
}

export function* rootSaga() {
    yield takeEvery(SAVE_EVENTS_SUCCESS, refreshFullPlan);
    yield takeEvery(SAVE_EVENTS_SUCCESS, refreshEvents);
}

export default combineReducers({
    formLoading,
    form,
    open,
    loading,
    errors,
    list,
    goalInfo,
    goalInfoLoading,
    showGoalCard,
    yPosition,
    findEvents,
});

export const changeField = (key, val) => ({
    type: CHANGE_FIELD,
    key,
    val,
});

export const changeSearchFilter = (key, val) => ({
    type: CHANGE_SEARCH_FILTER,
    key,
    val,
});

export const setError = (key, error) => ({
    type: SET_ERROR,
    key,
    error,
});

export const openModal = (event) => {
    const y = getPageY();

    return {
        type: OPEN_MODAL,
        event,
        yPos: y,
    };
};

export const closeModal = () => ({
    type: CLOSE_MODAL,
});

export const closeTipModal = tipBody => ({
    type: CLOSE_TIP_MODAL,
    tipBody,
});

export const fetchEvents = () => ({
    types: [FETCH_EVENTS, FETCH_EVENTS_SUCCESS, FETCH_EVENTS_FAILURE],
    promise: ({ getState }) => fetch(`${process.env.RTAPI_URL}/API_get_inplan.php`, {
        method: 'POST',
        body: prepareBody({
            plan_id: selectPlanId(getState()),
            runner_id: selectRunnerId(getState()),
        }),
    }).then(res => res.json()).then(res => mapEvents(res)),
});

const mapEvents = (events) => {
    const complete = events.Complete && events.Complete.map((event, index) => ({
        name: event.Name,
        date: event.Date === '0000-00-00' ? null : event.Date,
        dist: event.Dist,
        hr: event.Hr,
        min: event.Min,
        sec: event.Sec,
        index,
    }));
    const upcoming = events.Upcoming && events.Upcoming.map((event, index) => ({
        name: event.Name,
        date: event.Date === '0000-00-00' ? null : event.Date,
        dist: event.Dist,
        hr: event.Hr,
        min: event.Min,
        sec: event.Sec,
        index,
    }));
    return {
        complete,
        upcoming,
    };
};

export const getGoalRaceInfo = () => ({
    types: [GET_RACE_INFO, GET_RACE_INFO_SUCCESS, GET_RACE_INFO_FAILURE],
    promise: ({ getState }) => fetch(`${process.env.RTAPI_URL}/API_goalraceinfo.php`, {
        method: 'POST',
        body: prepareBody({
            plan_id: selectPlanId(getState()),
            runner_id: selectRunnerId(getState()),
        }),
    }).then(res => res.json()),
});

export const removeEvent = (event) => {
    const eventToRemove = event;
    eventToRemove.name = '';
    return updateEvents(eventToRemove);
};

export const updateEvents = event => ({
    types: [SAVE_EVENTS, SAVE_EVENTS_SUCCESS, SAVE_EVENTS_FAILURE],
    promise: ({ getState }) => fetch(`${process.env.RTAPI_URL}/API_edit_inplan.php`, {
        method: 'POST',
        body: prepareBody({
            plan_id: selectPlanId(getState()),
            runner_id: selectRunnerId(getState()),
            ...event,
            date: moment(event.date).format('M/D/YY'),
        }),
    }).then(res => res.json()),
});

export const fetchNewEvents = fields => ({
    types: [FETCH_NEW_EVENTS, FETCH_NEW_EVENTS_SUCCESS, FETCH_NEW_EVENTS_FAILURE],
    promise: ({ getState }) => fetch(`${process.env.RTAPI_URL}/API_upcoming_races.php`, {
        method: 'POST',
        body: prepareBody({
            plan_id: selectPlanId(getState()),
            runner_id: selectRunnerId(getState()),
            searchState: fields.searchState,
            searchStartDate: moment(fields.searchStartDate).format('YYYY-MM-DD'),
            searchEndDate: moment(fields.searchEndDate).format('YYYY-MM-DD'),
            distance_search: fields.searchDistance === 'All' ? '' : fields.searchDistance,
        }),
    }).then(res => res.json()),
});

const checkGoalInfo = (raceInfo) => {
    const info = {
        ...raceInfo,
        ...raceInfo.race_terrain,
        ...raceInfo.race_coursemap,
    };
    const showIfAny = [
        'terrain',
        'race_website',
        'elevation_map',
        'strava_link',
        'mapURL',
        'coursevideoURL',
        'race_strategy',
    ];
    return (showIfAny.some(field =>
        isSet(info[field]),
    ));
};



/** WEBPACK FOOTER **
 ** ./src/redux/events.js
 **/